import React from "react";

import { MetaTags } from "react-meta-tags";
import {
  Breadcrumbs,
  DashBreadcrumb,
} from "../../components/Common/Breadcrumb";
//../../../components/Common/Breadcrumb
import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

import ListComponent from "./components/StoreSelection/Approval.component";
const ManageQueue = () => { 
  const title = "Manage Refund";
  const description = "Refund List";
  return (
    <React.Fragment> 
      <div className="page-content">
        <MetaTags>
          <title>Refund List</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Queue List" breadcrumbItem="Manage Refund Approval Listing" />
            </Col>
          </Row>
         <ListComponent></ListComponent>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ManageQueue;
